import { createAction } from 'redux-actions';

export const setAudioGenres = createAction('SET_AUDIO_GENRES_DATA');
export const setAudioGenresLs = createAction('SET_AUDIO_GENRES_DATA_LS');
